import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card card-xl-stretch mb-xl-8" }
const _hoisted_2 = { class: "card-body pt-10" }
const _hoisted_3 = { class: "col-md-10" }
const _hoisted_4 = { class: "mb-13 text-center" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "d-flex flex-column mb-8 fv-row" }
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-12" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h3", null, "Email", -1)
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", null, "Họ tên", -1)
const _hoisted_12 = { class: "col-md-12" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("h3", null, "Vai trò", -1)
const _hoisted_14 = { class: "col-md-12" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("h3", null, "Mật khẩu", -1)
const _hoisted_16 = { class: "d-flex flex-stack mb-8 row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-5" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "me-5" }, [
    /*#__PURE__*/_createElementVNode("label", { class: "fs-6 fw-bold" }, "Trạng thái hoạt động"),
    /*#__PURE__*/_createElementVNode("div", { class: "fs-7 fw-bold text-warning" }, " Chú ý: Khi bạn tắt người dùng sẽ không thể truy cập vào hệ thống ")
  ])
], -1)
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("button", {
  type: "reset",
  id: "kt_modal_new_target_cancel",
  class: "btn btn-white me-3"
}, " Cancel ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_el_form, {
          id: "kt_modal_new_target_form",
          model: _ctx.objectData,
          rules: _ctx.rules,
          ref: "formRef",
          class: "form"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.objectData.name) + " - " + _toDisplayString(_ctx.objectData.email), 1)
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _createVNode(_component_el_form_item, { prop: "email" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.objectData.email,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.objectData.email) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_el_form_item, { prop: "name" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.objectData.name,
                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.objectData.name) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _hoisted_13,
                  _createVNode(_component_el_form_item, {
                    prop: "role",
                    label: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: _ctx.objectData.role,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.objectData.role) = $event)),
                        filterable: "",
                        "default-first-option": "",
                        placeholder: "Phân quyền người dùng"
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listDataRoles, (role, index) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              key: index,
                              label: role.name,
                              value: role._id
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createVNode(_component_el_form_item, {
                    prop: "password",
                    label: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: _ctx.objectData.password,
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.objectData.password) = $event))
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _hoisted_17,
              _createVNode(_component_el_switch, {
                modelValue: _ctx.objectData.status,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.objectData.status) = $event)),
                "active-color": "#13ce66",
                "inactive-color": "#ff4949",
                "active-value": "active",
                "inactive-value": "inactive"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _hoisted_19,
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submit())),
                loading: _ctx.loading
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.loading ? "Đang xử lý..." : "Lưu lại"), 1)
                ]),
                _: 1
              }, 8, ["loading"])
            ])
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])
    ])
  ]))
}